import { type ValidatorFunction } from 'ember-changeset-validations';
import { getIntl } from 'uplisting-frontend/validators/-internal';

export function customMessageValidator(
  validationMessageKey: string,
  validator: ValidatorFunction,
) {
  return (
    key: string,
    newValue: string,
    oldValue: string,
    changes: Record<string, unknown>,
    content: Record<string, unknown>,
  ): string | undefined => {
    const isInvalid =
      validator(key, newValue, oldValue, changes, content) !== true;

    if (isInvalid) {
      return getIntl().t(`validation_messages.custom.${validationMessageKey}`);
    }
  };
}
